/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Success_LabelInputs */

const en_mk_tut_success_label = /** @type {(inputs: Mk_Tut_Success_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How you know it worked:`)
};

const id_mk_tut_success_label = /** @type {(inputs: Mk_Tut_Success_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanda berhasil:`)
};

/**
* | output |
* | --- |
* | "How you know it worked:" |
*
* @param {Mk_Tut_Success_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_success_label = /** @type {((inputs?: Mk_Tut_Success_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Success_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_success_label(inputs)
	return en_mk_tut_success_label(inputs)
});